import { render, staticRenderFns } from "./InfoSvg.vue?vue&type=template&id=5dbfa409"
import script from "./InfoSvg.vue?vue&type=script&lang=js"
export * from "./InfoSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports